<template>
  <layout-basic>
    <v-container fluid style="padding-bottom: 15px">
      <v-row class="text-end">
        <v-col md="12">
          <v-card flat class="text-right v-card-bg-none">
            <v-card-actions style="display: flex; flex-wrap: wrap; gap: 1em">
              <v-btn color="secondary" outlined to="/admin/courses">
                <v-icon class="mr-1" small>fa-chevron-left</v-icon>Back to
                Course List
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn
                color="primary"
                outlined
                class="ml-0 add-course-button"
                @click.prevent="showAddVideoPanel"
              >
                Add Video
              </v-btn>
              <v-btn
                color="primary"
                outlined
                class="ml-0 add-course-button"
                @click.prevent="showAddDocumentPanel"
              >
                Add Document
              </v-btn>
              <v-btn
                color="primary"
                outlined
                class="ml-0 add-course-button"
                @click.prevent="showExternalLinkPanel"
              >
                Add External Link
              </v-btn>
              <!-- <v-btn
                color="primary"
                outlined
                class="ml-0 add-course-button"
                @click.prevent="showAddPowerPointPanel"
              >
                Add Powerpoint
              </v-btn> -->
              <v-btn
                color="primary"
                outlined
                class="ml-0 add-course-button"
                @click.prevent="showAddScormPanel"
              >
                Add SCORM
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="12">
          <div class="drag-instruction"><v-img contain :src="$globalConfig.APP_NAME === 'senso' ? '/static/senso-learn-information-icon.png' : '/static/information-icon-green.png'"></v-img>
            Reorder course content using the <v-img contain src="/static/content-reorder-small.png"></v-img>
            icon.<b>Please note:</b> Video content will always be displayed at the top of the course.</div>
        </v-col>
      </v-row>
      <v-row justify="center" align="center">
        <v-col align="center" class="pa-0 col-md-10 col-sm-10 col-xs-12">
          <div class="course-title-wrapper">
            <p class="course-title">
              {{ this.course.name }}
            </p>
            <v-tooltip v-if="course.is_membership" bottom>
              <template v-slot:activator="{ on }">
                <div v-on="on" class='isMember-Title'></div>
              </template>
              <span>Membership Content</span>
            </v-tooltip>
          </div>
        </v-col>
      </v-row>
    </v-container>
    <v-container fluid>
      <v-row justify="center" align="center">
        <v-col md="6" v-if="loading">
          <v-skeleton-loader
          class="card-loader mb-5"
          type="article"
          elevation="2"
        ></v-skeleton-loader>
        </v-col>
        <v-col md="6" v-else>
          <div v-if="assets.length > 0" class="mb-5">
            <!--<v-subheader>Drag items to rearrange training material order</v-subheader>-->
            <SortCourseMaterial :assets="assets" :id="id" />
          </div>
          <div v-else>
            <p class="pa-5">No course materials added.</p>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </layout-basic>
</template>

<script>
import LayoutBasic from '@/layouts/Dashboard';
import AddCourseMaterial from '@/components/admin/course/AddCourseMaterial';
import SortCourseMaterial from '@/components/admin/course/SortCourseMaterial';
import Publish from '@/components/admin/course/Publish';

import EnrolUsers from '@/components/admin/course/Enrol';
import ManageDeadlines from '@/components/admin/course/ManageDeadlines';
import RemoveUsers from '@/components/admin/course/RemoveUsers';
import EditCourse from '@/components/admin/course/Edit';

import AddDocument from '@/components/admin/course/trainingmaterial/Document';
import AddVideo from '@/components/admin/course/trainingmaterial/Video';
import ExternalLink from '@/components/admin/course/trainingmaterial/ExternalLink';
import AddPowerPoint from '@/components/admin/course/trainingmaterial/Powerpoint';
import AddSCORM from '@/components/admin/course/trainingmaterial/Scorm';

import { EventBus } from '@/event-bus.js';
import courseAPI from '@/api/course.js';

export default {
  components: {
    LayoutBasic,
    AddCourseMaterial,
    SortCourseMaterial,
    Publish,
  },
  data() {
    return {
      id: this.$route.params.id,
      courseMaterials: [],
      manage: true,
      file: false,
      canPublish: false,
      totalVideos: 0,
      noMaterialsMessage: 'Please add some course Materials',
      confirmDelete:
        'Are you sure you want to delete this Course? All Course users and associated data will be removed.',
      loading: false  
    };
  },
  computed: {
    assets() {
      return this.$store.getters.courseMaterials;
    },
    course() {
      return this.$store.getters.course;
    },
    published() {
      return this.$store.getters.course.published == 0 ? false : true;
    },
    topics() {
      return this.$store.getters.course.data.topics;
    },
  },
  created() {
    this.$store.dispatch('setCourse', {});
    this.$store.dispatch('setCourseMaterials', {});
  },
  mounted() {
    this.getCourse();
    this.setEventBus();
  },
  methods: {
    getCourse() {
      this.loading = true;
      courseAPI
        .getCourse(this.id, '?include=thumbnail,assets')
        .then((response) => {
          this.$store.dispatch('setCourse', response.data.data);
          this.$store.dispatch(
            'setCourseMaterials',
            response.data.data.assets.data
          );
          this.loading = false;
          //this.updateThumb();
        });
    },
    deleteCourse() {
      this.$snotify.confirm(this.confirmDelete, {
        backdrop:0.3,                         
        buttons: [
          { text: 'Cancel', className: 'toast-cancel-button' },
          {
            text: 'Continue',className: 'toast-continue-button',
            action: (toast) => this.processDeleteCourse(toast, this.id),
          }          
        ],
      });
    },
    processDeleteCourse(toast, id) {
      this.$snotify.remove(toast.id);
      courseAPI.deleteCourse(id).then(() => {
        this.$router.push({ path: '/admin/courses' });
      });
    },
    setEventBus() {
      //EventBus.$on("ASSET_ADDED", payload => {
      //  this.courseMaterials.push(payload.data.data);
      //  this.sortList(false);
      //});
      EventBus.$on('COURSE_UPDATED', (payload) => {
        this.course = payload;
        this.updateThumb();
        this.getCourse();
      });
    },
    showEnrolPanel() {
      this.$showPanel({
        component: EnrolUsers,
        props: {
          id: this.id,
        },
        openOn: 'right',
      });
    },
    showEditPanel() {
      this.$showPanel({
        component: EditCourse,
        props: {
          id: this.id,
          params: this.params,
          courseManager: true,
        },
        openOn: 'right',
      });
    },
    showManageDeadlinesPanel() {
      this.$showPanel({
        component: ManageDeadlines,
        disableBgClick: true,
        props: {
          id: this.id,
          params: this.params,
        },
        openOn: 'right',
      });
    },
    showRemoveUsersPanel() {
      this.$showPanel({
        component: RemoveUsers,
        disableBgClick: true,
        props: {
          id: this.id,
          params: this.params,
        },
        openOn: 'right',
      });
    },
    showAddDocumentPanel() {
      this.$showPanel({
        component: AddDocument,
        props: {
          id: this.id,
        },
        openOn: 'right',
      });
    },
    showAddVideoPanel() {
      this.$showPanel({
        component: AddVideo,
        props: {
          id: this.id,
        },
        openOn: 'right',
      });
    },
    showExternalLinkPanel() {
      this.$showPanel({
        component: ExternalLink,
        props: {
          id: this.id,
        },
        openOn: 'right',
      });
    },
    showAddPowerPointPanel() {
      this.$showPanel({
        component: AddPowerPoint,
        props: {
          id: this.id,
        },
        openOn: 'right',
      });
    },
    showAddScormPanel() {
      this.$showPanel({
        component: AddSCORM,
        props: {
          id: this.id,
        },
        openOn: 'right',
      });
    },
  },
};
</script>
<style scoped>
.drag-instruction{
  display: inline-flex;
  gap: 10px;
}
</style>